export default __webpack_public_path__ + "static/media/digitalocean-negative.60ee0369.svg";